import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import invalidateFields from '../invalidateFields';

export default function _local_cacheInvalidate(
  _parent: unknown,
  args: { field?: string },
  cache: Cache,
  _info: ResolveInfo,
) {
  const fieldName = args.field;
  if (!fieldName) {
    return;
  }

  invalidateFields([fieldName], cache);
}
